export default "__VITE_ASSET__DclqHFdW__"